import { render } from "./PriceUnitComponent.vue?vue&type=template&id=73f38836&scoped=true"
import script from "./PriceUnitComponent.vue?vue&type=script&lang=js"
export * from "./PriceUnitComponent.vue?vue&type=script&lang=js"

import "./PriceUnitComponent.vue?vue&type=style&index=0&id=73f38836&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f38836"]])

export default __exports__